export const namespacedPrefix = '[MANAGER]';
